import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CircleChartFilled = props => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" {...props}>
    <g id="Circle_Chart_Filled" data-name="Circle Chart Filled" transform="translate(-126 -100)">
      <path id="Path_7207" data-name="Path 7207" d="M397.557,100H397v8.943h8.943v-.557A8.422,8.422,0,0,0,397.557,100Z" transform="translate(-260.943)" />
      <path id="Path_7208" data-name="Path 7208" d="M204.08,377.833a8.307,8.307,0,0,0,13.839-6.276V371h-7.006Z" transform="translate(-75.182 -260.943)" />
      <path id="Path_7209" data-name="Path 7209" d="M226.256,161H225.7a8.294,8.294,0,0,0-4.868,1.579l5.424,5.427Z" transform="translate(-91.312 -58.736)" />
      <path id="Path_7210" data-name="Path 7210" d="M128.656,222.79a8.215,8.215,0,0,0-.546,11.546l6.046-6.046Z" transform="translate(0 -118.233)" />
    </g>
  </SvgIcon>
);

export default CircleChartFilled;
